import { ServicesCatalog, ServicesPlanning, ServicesShipments, SharedTitleText} from '~shared';

export type Options = [
  planing: ServicesPlanning,
  analytics: SharedTitleText,
  distribution: SharedTitleText,
  shipments: ServicesShipments,
  services: SharedTitleText,
  recycling: SharedTitleText,
  catalog: ServicesCatalog,
];

export const optionsBuilder = ([
  planing,
  analytics,
  distribution,
  shipments,
  services,
  recycling,
  catalog,
]: Options) => [
  {
    title: catalog.title,
    presentation: catalog.presentation.url,
    manager: catalog.manager,
    contacts: catalog.contacts,
  },
  {
    title: distribution.title,
    titleWidth: 'mb:max-tb:max-w-[209px]',
    description: distribution.text,
    textSize: 'dk:text-textM tb:text-textM',
    image: {
      src: '/images/services/service_1.jpg',
      widthDk: 340,
      heightDk: 264,
      widthTb: 260,
      heightTb: 202,
      widthMb: 345,
      heightMb: 268,
    },
  },
  {
    title: shipments.title,
    titleWidth: 'mb:max-tb:max-w-[209px]',
    description: shipments.text,
    textSize: 'tb:text-textM ',
    textSubtitles: [
      shipments.auto?.title,
      shipments.sea?.title,
      shipments.avia?.title,
      shipments.customs?.title,
    ],
    subtitles: [
      {
        icon: '/images/services/control-1.svg',
        title: shipments.auto?.title,
        list: [
          {
            titleWidth: 'dk:max-w-[293px]',
            //title: 'services.services.4.auto.2.title',
            title: shipments.auto?.sections![1].title,
            //description: 'services.services.4.auto.2.text',
            description: shipments.auto?.sections![1].text,
          },
          {
            titleWidth: 'dk:max-w-[245px]',
            title: shipments.auto?.sections![0].title,
            description: shipments.auto?.sections![0].text,
          },

          {
            titleWidth: 'dk:max-w-[300px]',
            title: shipments.auto?.sections![2].title,
            description: shipments.auto?.sections![2].text,
          },
        ],
      },
      {
        icon: '/images/services/control-2.svg',
        title: shipments.sea?.title,
        list: [
          {
            titleWidth: 'dk:max-w-[245px]',
            title: shipments.sea?.sections![0].title,
            description: shipments.sea?.sections![0].text,
          },
          {
            titleWidth: 'dk:max-w-[245px]',
            title: shipments.sea?.sections![2].title,
            description: shipments.sea?.sections![2].text,
          },
          {
            titleWidth: 'dk:max-w-[245px]',
            title: shipments.sea?.sections![1].title,
            description: shipments.sea?.sections![1].text,
          },
        ],
      },
      {
        icon: '/images/services/control-3.svg',
        title: shipments?.avia?.title,
        list: [
          {
            titleWidth: 'dk:max-w-[245px]',
            title: shipments.avia?.sections![0].title,
            description: shipments.avia?.sections![0].text,
          },
          {
            titleWidth: 'dk:max-w-[245px]',
            title: shipments.avia?.sections![1].title,
            description: shipments.avia?.sections![1].text,
          },
          {
            titleWidth: 'dk:max-w-[245px]',
            title: shipments.avia?.sections![2].title,
            description: shipments.avia?.sections![2].text,
          },
        ],
      },
      {
        icon: '/images/services/control-4.svg',
        title: shipments.customs?.title,
        description: shipments.customs?.text,
      },
    ],
  },
  {
    title: planing.title,
    titleWidth: 'mb:max-tb:max-w-[209px]',
    description: planing.text,
    textSize: 'tb:text-textM',
    subtitle: planing.roso?.title,
    subtitleIcon: '/images/services/rosso.svg',
    textUl: [
      {
        icon: '/images/services/advantage-1.svg',
        title: planing.roso?.sections![0].title,
        description: planing.roso?.sections![0].text,
      },
      {
        icon: '/images/services/advantage-2.svg',
        title: planing.roso?.sections![1].title,
        description: planing.roso?.sections![1].text,
      },
      {
        icon: '/images/services/advantage-3.svg',
        title: planing.roso?.sections![2].title,
        description: planing.roso?.sections![2].text,
      },
      {
        icon: '/images/services/advantage-4.svg',
        title: planing.roso?.sections![3].title,
        description: planing.roso?.sections![3].text,
      },
      {
        icon: '/images/services/advantage-5.svg',
        title: planing.roso?.sections![4].title,
        description: planing.roso?.sections![4].text,
      },
    ],
    advantages: [
      {
        text: planing.roso?.advantages![0].text,
        textWidth: 'dk:max-w-[261px] tb:max-w-[348px]',
        order: 'mb:max-tb:order-[0]',
      },
      {
        text: planing.roso?.advantages![4].text,
        textWidth: 'dk:max-w-[204px] tb:max-w-[377px] tb:max-dk:mt-[-26px]',
        order: 'mb:max-tb:order-[4]',
      },
      {
        text: planing.roso?.advantages![1].text,
        textWidth: 'dk:max-w-[278px] tb:max-w-[328px]',
        order: 'mb:max-tb:order-[1]',
      },
      {
        text: planing.roso?.advantages![5].text,
        textWidth: 'dk:max-w-[186px] tb:max-w-[377px] tb:max-dk:mt-[-74px]',
        order: 'mb:max-tb:order-[5]',
      },
      {
        text: planing.roso?.advantages![2].text,
        textWidth: 'dk:max-w-[234px] tb:max-w-[388px]',
        order: 'mb:max-tb:order-[2]',
      },
      {
        text: planing.roso?.advantages![6].text,
        textWidth: 'dk:max-w-[200px] tb:max-w-[377px] tb:max-dk:mt-[-96px]',
        order: 'mb:max-tb:order-[6]',
      },
      {
        text: planing.roso?.advantages![3].text,
        textWidth: 'dk:max-w-[332px] tb:max-w-[388px]',
        order: 'mb:max-tb:order-[3]',
      },
      {
        text: planing.roso?.advantages![7].text,
        textWidth: 'dk:max-w-[332px] tb:max-w-[377px] tb:max-dk:mt-[-98px]',
        order: 'mb:max-tb:order-[7]',
      },
    ],
  },
  {
    title: analytics.title,
    titleWidth: 'mb:max-tb:max-w-[209px]',
    description: analytics.text,
    textSize: 'dk:text-textM tb:text-textM',
    image: {
      src: '/images/services/service_2.jpg',
      widthDk: 340,
      heightDk: 264,
      widthTb: 260,
      heightTb: 202,
      widthMb: 345,
      heightMb: 268,
    },
  },

  {
    title: services.title,
    titleWidth: 'mb:max-tb:max-w-[308px]',
    description: services.text,
    textSize: 'tb:text-textM',

    image: {
      src: '/images/services/service_3.jpg',
      widthDk: 340,
      heightDk: 264,
      widthTb: 260,
      heightTb: 202,
      widthMb: 345,
      heightMb: 268,
    },
  },
  {
    title: recycling.title,
    titleWidth: 'mb:max-tb:max-w-[300px]',
    description: recycling.text,
    textSize: 'tb:text-textM',
    image: {
      src: '/images/services/service_4.jpg',
      widthDk: 340,
      heightDk: 265,
      widthTb: 259,
      heightTb: 202,
      widthMb: 345,
      heightMb: 268,
    },
  },
];
